import React from "react";
import {Route} from "react-router-dom";

import CheckIndex from "./index";

const data = [<Route exact key="CheckIndex" path="/check/index" element={<CheckIndex />} />];

export default data;
